import * as React from 'react';
import SvgIcon, {SvgIconProps} from 'material-ui/SvgIcon';

export class SportappLogo extends React.Component<SvgIconProps, undefined> {
  render() {
    const props = Object.assign({viewBox: '0 0 520 520', color: 'white'}, this.props);

    return (
      <SvgIcon {...props} style={{height: '100%', width: '100%'}}>
        <g fill="#19cffc">
          <path d="M121 98.5H45c-8.291 0-15-6.709-15-15s6.709-15 15-15h76c8.291 0 15 6.709 15 15s-6.709 15-15 15zM121 218.5H45c-8.291 0-15-6.709-15-15s6.709-15 15-15h76c8.291 0 15 6.709 15 15s-6.709 15-15 15zM91 158.5H15c-8.291 0-15-6.709-15-15s6.709-15 15-15h76c8.291 0 15 6.709 15 15s-6.709 15-15 15z" />
        </g>
        <g fill="#2864f0">
          <path d="M280.141 51.039c-11.924-7.925-27.744-6.357-37.852 3.75l-82.5 82.5c-11.719 11.719-11.719 30.703 0 42.422s30.703 11.719 42.422 0l65.112-65.112 46.593 33.563 63.724-29.623-97.499-67.5zM219.789 242.289l-195 195c-11.719 11.719-11.719 30.703 0 42.422 11.718 11.718 30.703 11.719 42.422 0L241 305.922l-21.211-63.633z" />
        </g>
        <g fill="#3389ff">
          <path d="M482 203.5h-91v-60c0-11.793-7.134-22.955-18.536-27.684-11.48-4.748-24.401-1.812-32.684 6.482L219.789 242.289c-11.719 11.719-11.719 30.703 0 42.422l68.789 68.789-83.789 83.789c-11.719 11.719-11.719 30.703 0 42.422 11.718 11.718 30.703 11.719 42.422 0l105-105c11.719-11.719 11.719-30.703 0-42.422L283.422 263.5 331 215.922V233.5c0 16.567 13.433 30 30 30h121c16.567 0 30-13.433 30-30s-13.433-30-30-30z" />
          <circle cx={436} cy={68.5} r={45} />
        </g>
      </SvgIcon>
    );
  }
}


export default SportappLogo;


// WEBPACK FOOTER //
// ./src/themes/sportapp/components/SportappLogo.tsx